// To generate a new file similar to this one, run `pay js:run gql-v1 --type=lazy-query --name=<name> --dir=path/to/dir`.
// You can freely edit this file. To update the generated types, run `eslint` in `--fix` mode.
// Do not delete this comment. https://go/gql-operation-definition

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import type {
  V1QueryOptionsWithoutVariables,
  V1QueryOptions,
  V1QueryReturn,
  AccountToken,
} from '@stripe-internal/data-v1/types';
import {gql} from '@sail/data';
import {useV1Query} from '@stripe-internal/data-v1';

import type {GraphQlDocument, GraphQlFragmentUnion} from '@sail/data';

import type {
  Exact,
  InputMaybe,
  V1ContextInput,
  OpenapiGetV1CryptoInternalSetupSessionInput,
} from '@stripe-internal/data-v1/schema/types';

import {setupSessionFragment} from 'src/api/graphql/setupSessionFragment';

import type {
  SetupSessionFragmentData,
  SetupSessionFragmentToken,
} from 'src/api/graphql/setupSessionFragment';

const doc = gql`
  query SetupSessionQuery(
    $input: OpenapiGetV1CryptoInternalSetupSessionInput
    $v1Context: V1ContextInput!
  ) {
    v1CryptoInternalSetupSession(input: $input, v1Context: $v1Context) {
      id
      ...SetupSessionFragment
    }
  }
  ${setupSessionFragment}
`;

export const setupSessionQuery: SetupSessionQueryDocument = doc;

// Fill these options as needed. Options are documented at
// http://go/sail/apis/data/graphql-usage/the-basics-runtime#operation-options
const setupSessionQueryOptions: V1QueryOptionsWithoutVariables<SetupSessionQueryDocument> =
  {
    fetchPolicy: 'no-cache',
  };

export default function useSetupSessionQuery(
  options: V1QueryOptions<SetupSessionQueryDocument>,
): V1QueryReturn<SetupSessionQueryDocument> {
  return useV1Query(setupSessionQuery, {
    ...setupSessionQueryOptions,
    ...options,
  });
}

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type SetupSessionQueryVariables = Exact<{
  input?: InputMaybe<OpenapiGetV1CryptoInternalSetupSessionInput>;
  v1Context: V1ContextInput;
}>;

export type SetupSessionQueryData = {
  readonly __typename: 'Query';
  readonly v1CryptoInternalSetupSession: GraphQlFragmentUnion<
    {
      readonly __typename: 'OpenapiCryptocurrencyPayinsResourceCryptoSetupSession';
      readonly id: string;
    },
    [SetupSessionFragmentData]
  > | null;
};

export type SetupSessionQueryToken = SetupSessionFragmentToken &
  AccountToken<{Query_v1CryptoInternalSetupSession: true}>;

// Temporarily duplicating the token type to facilitate migration.
// This will be removed as part of go/rename-permissions-to-token work.
export type SetupSessionQueryPermissions = SetupSessionQueryToken;

export type SetupSessionQueryDocument = GraphQlDocument<
  SetupSessionQueryData,
  SetupSessionQueryVariables,
  SetupSessionQueryToken
>;
